<div class="loader-container" [style]="{ height: height }">
  <!-- <div class="background"></div> -->
  <div class="loader-container translucent-div">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden"></span>
    </div>
    <div>{{ loadingAction }}...</div>
  </div>
</div>
